import React, { Component } from 'react'

class Info extends Component {

  render() {
    const { advising } = this.props
    var middleInitial = "-."

    // check for middle initial
    if (advising.get('middle_name') !== "") {
      middleInitial = advising.get('middle_name')[0] + "."
    }

    return (
      <div className="cor-info">
        <table className="table">
          <tbody>
            <tr>
              <td><span className="info-label">LAST NAME: <strong>{ advising.get('last_name') }</strong></span></td>
              <td><span className="info-label">FIRST NAME: <strong>{ advising.get('first_name') }</strong></span></td>
              <td><span className="info-label">MIDDLE INITIAL: <strong>{ middleInitial }</strong></span></td>
              <td><span className="info-label">EXT: <strong>{ advising.get('suffix_name') }</strong></span></td>
            </tr>
            <tr>
              <td><span className="info-label">STUDENT ID No: <strong>{ advising.get('student_id') }</strong></span></td>
              <td><span className="info-label">COLLEGE: <strong>{ advising.get('college_code') }</strong></span></td>
              <td><span className="info-label">SCHOLARSHIP: <strong>{ advising.get('scholarship_code') }</strong></span></td>
              <td><span className="info-label">SEX: <strong>{ advising.get('sex') }</strong></span></td>
            </tr>
            <tr>
              <td><span className="info-label">COURSE/MAJOR: <strong>{ advising.get('course_code') }</strong></span></td>
              <td><span className="info-label">YEAR LEVEL: <strong>{ advising.get('level') }</strong></span></td>
              <td><span className="info-date">Date Registered: <strong className="info-date">{ advising.get('registered_date') }</strong></span></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default Info



// WEBPACK FOOTER //
// ./src/containers/COR2/info.js